import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { FiDownload, FiTrash2 } from "react-icons/fi";
import {
    AiOutlineFilePdf,
    AiOutlineFileImage,
    AiOutlineFileWord,
    AiOutlineFileExcel,
    AiOutlineFileUnknown,
} from "react-icons/ai";

import Overlay from "../../../Componentes/Overlay";
import FormComp from "../../../Componentes/FormComp";
import formStyle from "../../../Componentes/FormComp/FormComp.module.css";
import Modal from "../../../Componentes/Utils/Modal";
import Formulario from "../../../Componentes/Utils/Formulario";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader";
import ObservacoesSection from "./ObservacoesSection";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";

const ModalTitle = styled.h3`
    margin: 0 0 18px 0;
    padding: 0 0 12px 2px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 15px;
    font-weight: 700;
    color: #263b4b;
    letter-spacing: 0.02em;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
`;

const FormSection = styled.div`
    width: 100%;
    text-align: left;
    position: relative;

    .${formStyle.formChild} p {
        margin: 15px 0 5px 0;
        padding-left: 2px;
        text-align: left;
    }
`;

const ActionsRow = styled.div`
    display: flex;
    gap: 6px;
    margin-top: 15px;
    margin-bottom: 8px;
`;

const ActionButton = styled.button`
    flex: 1;
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 10px;
    outline: none;
    box-sizing: border-box;
    background-color: ${(props) => (props.$amarelo ? "#e0e000" : "#4caf50")};
    color: ${(props) => (props.$amarelo ? "#1f2937" : "#fff")};
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover:not(:disabled) {
        background-color: ${(props) => (props.$amarelo ? "#ccc900" : "#45a049")};
    }

    &:disabled {
        background-color: #c1c1c1;
        color: #fff;
        cursor: not-allowed;
    }
`;

const ConfirmOverlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 12px;
`;

const ConfirmBox = styled.div`
    width: min(350px, 92%);
    background-color: #fff;
    border-radius: 5px;
    padding: 20px 16px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ConfirmTitle = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    text-align: center;
    line-height: 1.4;
`;

const ConfirmActions = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 20px;
    width: 100%;
`;

const ConfirmButton = styled.button`
    flex: 1;
    height: 36px;
    border: none;
    border-radius: 5px;
    font-weight: 700;
    cursor: pointer;
    background-color: ${(props) => (props.$primary ? "#0b6e4f" : "#e5e7eb")};
    color: ${(props) => (props.$primary ? "#fff" : "#1f2937")};

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

/* ─── Seção de anexos ─────────────────────────────────────────────── */

const SecaoAnexos = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 16px;
`;

const AnexosLabel = styled.p`
    margin: 0 0 2px 2px;
    font-size: 12px;
    font-weight: 700;
    color: #263b4b;
    letter-spacing: 0.02em;
`;

const SemAnexos = styled.p`
    margin: 0;
    font-size: 13px;
    color: #6b7280;
    padding: 10px 12px;
    background-color: #f8fafc;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    text-align: center;
`;

const AnexosCarregando = styled(SemAnexos)`
    color: #475569;
`;

const CardAnexo = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background-color: ${(p) => (p.$confirming ? "#fff5f5" : "#f8fafc")};
    border: 1px solid ${(p) => (p.$confirming ? "#fecaca" : "#e2e8f0")};
    border-radius: 10px;
    transition: border-color 0.15s ease, background-color 0.15s ease;
    min-width: 0;
`;

const AnexoIconWrap = styled.div`
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;

const AnexoInfo = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const AnexoNome = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const AnexoTamanho = styled.span`
    font-size: 11px;
    color: #64748b;
`;

const AnexoAcoes = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
`;

const BotaoAnexo = styled.button`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;

    color: ${(p) => (p.$danger ? "#b91c1c" : "#1d4ed8")};
    background-color: ${(p) =>
        p.$danger ? "rgba(185,28,28,0.10)" : "rgba(29,78,216,0.08)"};
    border: 1px solid transparent;

    &:hover {
        background-color: ${(p) =>
            p.$danger ? "rgba(185,28,28,0.20)" : "rgba(29,78,216,0.18)"};
        border-color: ${(p) =>
            p.$danger ? "rgba(185,28,28,0.45)" : "rgba(29,78,216,0.4)"};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: 2px solid ${(p) => (p.$danger ? "#b91c1c" : "#1d4ed8")};
        outline-offset: 2px;
    }
`;

const AnexoConfirmBox = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
`;

const AnexoConfirmLabel = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: #b91c1c;
    white-space: nowrap;
`;

const AnexoConfirmBtn = styled.button`
    all: unset;
    padding: 4px 10px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.15s ease;

    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#dc2626")};
    color: ${(p) => (p.$cancel ? "#333" : "#fff")};

    &:hover {
        background-color: ${(p) => (p.$cancel ? "#d1d5db" : "#b91c1c")};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const BotaoEnviarAnexos = styled.button`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.15s ease;
    background-color: #263b4b;
    color: #fff;

    &:hover:not(:disabled) {
        background-color: #1e2f3c;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

/* ─── Helpers de anexo ────────────────────────────────────────────── */

function formatarTamanho(bytes) {
    if (bytes == null || bytes === "" || Number.isNaN(Number(bytes))) return null;
    const b = Number(bytes);
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / (1024 * 1024)).toFixed(1)} MB`;
}

function nomeAnexo(anexo) {
    if (anexo?.nome_original) return anexo.nome_original;
    const parts = String(anexo?.caminho ?? "").split("/");
    return parts[parts.length - 1] || "Arquivo";
}

function getFileIcon(filename) {
    const name = String(filename ?? "").toLowerCase();
    if (/\.(png|jpe?g|gif|webp|bmp)$/i.test(name))
        return <AiOutlineFileImage size={20} color="#4a90e2" />;
    if (name.endsWith(".pdf"))
        return <AiOutlineFilePdf size={20} color="#e63946" />;
    if (/\.(doc|docx)$/i.test(name))
        return <AiOutlineFileWord size={20} color="#2a6db0" />;
    if (/\.(xls|xlsx)$/i.test(name))
        return <AiOutlineFileExcel size={20} color="#207245" />;
    return <AiOutlineFileUnknown size={20} color="#555" />;
}

const TIPO_ATENDIMENTO_OPTIONS = ["INTERNO", "EXTERNO"];
const INTERNACAO_OPTIONS = ["NÃO", "SIM"];
const STATUS_INTERNACAO_OPTIONS = ["EM ANDAMENTO", "ALTA", "ÓBITO"];

const ModalEditarAtendimento = ({ atendimento, fechar, onSaved }) => {
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();

    const [queixa, setQueixa] = useState(atendimento?.queixa ?? "");
    const [tipoAtendimento, setTipoAtendimento] = useState(atendimento?.atendimento ?? "");
    const [internacao, setInternacao] = useState(atendimento?.internacao ?? "");
    const [statusInternacao, setStatusInternacao] = useState(atendimento?.obito_alta ?? "");
    const [descricao, setDescricao] = useState(atendimento?.descricao ?? "");
    const [solucao, setSolucao] = useState(atendimento?.solucao ?? "");
    const [custos, setCustos] = useState(
        atendimento?.custo != null ? Number(atendimento.custo).toFixed(2) : "0.00"
    );
    const [queixaOptions, setQueixaOptions] = useState([]);
    const [confirmAction, setConfirmAction] = useState(null);
    const [saving, setSaving] = useState(false);

    const [anexos, setAnexos] = useState([]);
    const [loadingAnexos, setLoadingAnexos] = useState(true);
    const [confirmDeleteAnexoId, setConfirmDeleteAnexoId] = useState(null);
    const [deletingAnexoId, setDeletingAnexoId] = useState(null);
    const [arquivosPendentes, setArquivosPendentes] = useState([]);
    const [enviandoAnexos, setEnviandoAnexos] = useState(false);

    const formRef = useRef(null);

    useEffect(() => {
        const loadQueixas = async () => {
            try {
                const { data } = await api.get(
                    "/Painel/API/AtendimentoAmb/Queixas/List/index.php"
                );
                const lista = data?.data ?? data;
                if (!Array.isArray(lista)) return;
                setQueixaOptions(lista.map((item) => item.descricao).filter(Boolean));
            } catch (err) {
                console.error("Erro ao carregar queixas:", err);
            }
        };
        loadQueixas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const loadAnexos = async () => {
            if (!atendimento?.id) {
                setLoadingAnexos(false);
                return;
            }
            setLoadingAnexos(true);
            try {
                const { data } = await api.get("/Painel/API/AtendimentoAmb/Get/index.php", {
                    params: { id: atendimento.id },
                });
                const lista = Array.isArray(data?.data?.anexos) ? data.data.anexos : [];
                setAnexos(lista);
            } catch (err) {
                console.error("Erro ao carregar anexos:", err);
                setAnexos([]);
            } finally {
                setLoadingAnexos(false);
            }
        };
        loadAnexos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [atendimento?.id]);

    const handleDeleteAnexo = async (anexoId) => {
        setDeletingAnexoId(anexoId);
        try {
            const { data } = await api.post(
                "/Painel/API/AtendimentoAmb/DeleteAnexo/index.php",
                { id: anexoId }
            );
            if (data?.success) {
                notifySuccess(data?.message || "Anexo removido.");
                setAnexos((prev) => prev.filter((a) => a.id !== anexoId));
                setConfirmDeleteAnexoId(null);
            } else {
                notifyError(data?.message || "Não foi possível remover o anexo.");
            }
        } catch (err) {
            console.error(err);
            notifyError(err?.response?.data?.message || "Erro ao remover anexo.");
        } finally {
            setDeletingAnexoId(null);
        }
    };

    const handleEnviarAnexos = async () => {
        if (arquivosPendentes.length === 0 || enviandoAnexos) return;

        setEnviandoAnexos(true);
        try {
            const formData = new FormData();
            formData.append("id", atendimento.id);
            arquivosPendentes.forEach((item) => formData.append("files[]", item.file));

            const { data } = await api.post(
                "/Painel/API/AtendimentoAmb/AddAnexo/index.php",
                formData
            );

            if (data?.success) {
                notifySuccess(data?.message || "Anexos enviados com sucesso.");
                const novos = Array.isArray(data?.inseridos) ? data.inseridos : [];
                setAnexos((prev) => [...prev, ...novos]);
                setArquivosPendentes([]);
            } else {
                notifyError(data?.message || "Erro ao enviar anexos.");
            }
        } catch (err) {
            console.error(err);
            notifyError(err?.response?.data?.message || "Erro ao enviar anexos.");
        } finally {
            setEnviandoAnexos(false);
        }
    };

    const handleTipoAtendimentoChange = useCallback((e) => {
        setTipoAtendimento(e.target.value);
        setInternacao("");
        setStatusInternacao("");
    }, []);

    const handleInternacaoChange = useCallback((e) => {
        const value = e.target.value;
        setInternacao(value);
        if (value !== "SIM") {
            setStatusInternacao("");
        }
    }, []);

    const handleCustosChange = (e) => {
        const digits = e.target.value.replace(/\D/g, "");
        const numero = parseInt(digits || "0", 10) / 100;
        setCustos(numero.toFixed(2));
    };

    const validateForm = useCallback(() => {
        const form = formRef.current;
        if (form && !form.checkValidity()) {
            form.reportValidity();
            return false;
        }
        return true;
    }, []);

    const handleActionClick = (action) => (e) => {
        e.preventDefault();
        if (saving) return;
        if (!validateForm()) return;
        setConfirmAction(action);
    };

    const handleConfirmCancel = () => {
        if (saving) return;
        setConfirmAction(null);
    };

    const handleConfirm = async () => {
        if (!confirmAction || saving) return;

        setSaving(true);
        setConfirmAction(null);

        const formData = new FormData();
        formData.append("id", atendimento.id);
        formData.append("queixa", queixa);
        formData.append("atendimento", tipoAtendimento);
        formData.append("descricao", descricao);
        formData.append("solucao", solucao);
        formData.append("custo", custos);
        formData.append("acao", confirmAction);
        formData.append("internacao", tipoAtendimento === "EXTERNO" ? internacao : "");
        formData.append(
            "status_internacao",
            tipoAtendimento === "EXTERNO" && internacao === "SIM" ? statusInternacao : ""
        );
        formData.append("data_inicial", atendimento.data_inicio ?? "");

        try {
            const { data } = await api.post(
                "/Painel/API/AtendimentoAmb/Update/index.php",
                formData
            );

            if (data?.success) {
                notifySuccess(data?.message || "Atendimento atualizado com sucesso.");
                onSaved?.();
                fechar();
                return;
            }

            notifyError(data?.message || "Erro ao atualizar atendimento.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao atualizar atendimento.";
            notifyError(msg);
        } finally {
            setSaving(false);
        }
    };

    const confirmTitle =
        confirmAction === "finalizar"
            ? "DESEJA FINALIZAR O ATENDIMENTO?"
            : "DESEJA COLOCAR O ATENDIMENTO EM ANDAMENTO?";

    return (
        <Overlay state>
            <Modal header close={fechar} size="md">
                <ModalTitle>EDITAR ATENDIMENTO #{atendimento?.id}</ModalTitle>

                <FormSection>
                    <Formulario ref={formRef} onSubmit={(e) => e.preventDefault()}>
                        {/* Dados do colaborador — somente leitura */}
                        <FormComp title="CPF" type="text" valor={atendimento?.cpf} readOnly />
                        <FormComp title="NOME" type="text" valor={atendimento?.nome} readOnly />
                        <FormComp
                            title="CENTRO DE CUSTO"
                            type="text"
                            valor={atendimento?.centro_custo}
                            readOnly
                        />
                        <FormComp
                            title="CONTRATO"
                            type="text"
                            valor={atendimento?.contrato}
                            readOnly
                        />
                        <FormComp title="LÍDER" type="text" valor={atendimento?.lider} readOnly />

                        {/* Campos editáveis */}
                        <FormComp
                            title="QUEIXA / OCORRÊNCIA"
                            type="select"
                            options={queixaOptions}
                            valor={queixa}
                            changeFunc={(e) => setQueixa(e.target.value)}
                            required
                        />
                        <FormComp
                            title="TIPO ATENDIMENTO"
                            type="select"
                            options={TIPO_ATENDIMENTO_OPTIONS}
                            valor={tipoAtendimento}
                            changeFunc={handleTipoAtendimentoChange}
                            required
                        />
                        {tipoAtendimento === "EXTERNO" && (
                            <FormComp
                                title="INTERNAÇÃO"
                                type="select"
                                options={INTERNACAO_OPTIONS}
                                valor={internacao}
                                changeFunc={handleInternacaoChange}
                                required
                            />
                        )}
                        {tipoAtendimento === "EXTERNO" && internacao === "SIM" && (
                            <FormComp
                                title="STATUS INTERNAÇÃO"
                                type="select"
                                options={STATUS_INTERNACAO_OPTIONS}
                                valor={statusInternacao}
                                changeFunc={(e) => setStatusInternacao(e.target.value)}
                                required
                            />
                        )}
                        <FormComp
                            title="DESCRIÇÃO"
                            type="textarea"
                            valor={descricao}
                            changeFunc={(e) => setDescricao(e.target.value)}
                            required
                        />
                        <FormComp
                            title="SOLUÇÃO"
                            type="textarea"
                            valor={solucao}
                            changeFunc={(e) => setSolucao(e.target.value)}
                            required
                        />
                        <FormComp
                            title="CUSTOS"
                            type="text"
                            placeholder="0.00"
                            valor={custos}
                            changeFunc={handleCustosChange}
                            required
                        />

                        <ObservacoesSection
                            atendimentoId={atendimento?.id}
                            canAdd
                        />

                        <SecaoAnexos>
                            <AnexosLabel>ANEXOS</AnexosLabel>

                            {loadingAnexos ? (
                                <AnexosCarregando>Carregando anexos…</AnexosCarregando>
                            ) : anexos.length === 0 ? (
                                <SemAnexos>Nenhum anexo.</SemAnexos>
                            ) : (
                                anexos.map((anexo) => {
                                    const nome = nomeAnexo(anexo);
                                    const tamanho = formatarTamanho(anexo.tamanho);
                                    const isConfirming = confirmDeleteAnexoId === anexo.id;
                                    const isDeleting = deletingAnexoId === anexo.id;

                                    return (
                                        <CardAnexo
                                            key={anexo.id ?? anexo.caminho}
                                            $confirming={isConfirming}
                                        >
                                            <AnexoIconWrap>
                                                {getFileIcon(nome)}
                                            </AnexoIconWrap>

                                            <AnexoInfo>
                                                <AnexoNome title={nome}>{nome}</AnexoNome>
                                                {tamanho && (
                                                    <AnexoTamanho>{tamanho}</AnexoTamanho>
                                                )}
                                            </AnexoInfo>

                                            {isConfirming ? (
                                                <AnexoConfirmBox>
                                                    <AnexoConfirmLabel>Confirmar?</AnexoConfirmLabel>
                                                    <AnexoConfirmBtn
                                                        type="button"
                                                        $cancel
                                                        disabled={isDeleting}
                                                        onClick={() => setConfirmDeleteAnexoId(null)}
                                                    >
                                                        NÃO
                                                    </AnexoConfirmBtn>
                                                    <AnexoConfirmBtn
                                                        type="button"
                                                        disabled={isDeleting}
                                                        onClick={() => handleDeleteAnexo(anexo.id)}
                                                    >
                                                        {isDeleting ? "…" : "SIM"}
                                                    </AnexoConfirmBtn>
                                                </AnexoConfirmBox>
                                            ) : (
                                                <AnexoAcoes>
                                                    <BotaoAnexo
                                                        as="a"
                                                        href={anexo.caminho}
                                                        download
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="Baixar anexo"
                                                    >
                                                        <FiDownload size={14} />
                                                    </BotaoAnexo>
                                                    <BotaoAnexo
                                                        $danger
                                                        type="button"
                                                        title="Remover anexo"
                                                        onClick={() =>
                                                            setConfirmDeleteAnexoId(anexo.id)
                                                        }
                                                    >
                                                        <FiTrash2 size={14} />
                                                    </BotaoAnexo>
                                                </AnexoAcoes>
                                            )}
                                        </CardAnexo>
                                    );
                                })
                            )}
                            <MultiFileUploader
                                files={arquivosPendentes}
                                setFiles={setArquivosPendentes}
                            />

                            {arquivosPendentes.length > 0 && (
                                <BotaoEnviarAnexos
                                    type="button"
                                    disabled={enviandoAnexos}
                                    onClick={handleEnviarAnexos}
                                >
                                    {enviandoAnexos
                                        ? "ENVIANDO…"
                                        : `ENVIAR ${arquivosPendentes.length} ANEXO${arquivosPendentes.length > 1 ? "S" : ""}`}
                                </BotaoEnviarAnexos>
                            )}
                        </SecaoAnexos>

                        <ActionsRow>
                            <ActionButton
                                type="button"
                                $amarelo
                                onClick={handleActionClick("aguardar")}
                                disabled={saving}
                            >
                                EM ANDAMENTO
                            </ActionButton>
                            <ActionButton
                                type="button"
                                onClick={handleActionClick("finalizar")}
                                disabled={saving}
                            >
                                FINALIZAR
                            </ActionButton>
                        </ActionsRow>
                    </Formulario>
                </FormSection>
                {confirmAction && (
                    <ConfirmOverlay>
                        <ConfirmBox>
                            <ConfirmTitle>{confirmTitle}</ConfirmTitle>
                            <ConfirmActions>
                                <ConfirmButton
                                    type="button"
                                    onClick={handleConfirmCancel}
                                    disabled={saving}
                                >
                                    NÃO
                                </ConfirmButton>
                                <ConfirmButton
                                    type="button"
                                    $primary
                                    onClick={handleConfirm}
                                    disabled={saving}
                                >
                                    {saving ? "SALVANDO…" : "SIM"}
                                </ConfirmButton>
                            </ConfirmActions>
                        </ConfirmBox>
                    </ConfirmOverlay>
                )}
                
            </Modal>
        </Overlay>
    );
};

export default ModalEditarAtendimento;
